import React, { useEffect, useState } from "react";
import * as theme from "../../theme";
import { useDispatch, useSelector } from "react-redux";
import TransactionDetails from "./TransactionDetails";
import Loader3Orange from "../../general/Loader3Orange";
import DateFnsUtils from "@date-io/date-fns";
import LoadingSpinner from "../BinderLoading";

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import {
  getAllTransactionList,
  allTransactionsList,
  transactionDetail,
  getTransactionDetails,
} from "../../store/stripeTransaction";
import { Fragment } from "react";
import Button from "react-bootstrap/Button";
import VisibilityIcon from "@material-ui/icons/Visibility";
import {
  transactionModalOpened,
  getTransactionModalState,
} from "../../store/components";
import Modal from "react-modal";
import translations from "../../utils/translations";
import { getBrokerInformation } from "../../store/broker";

const TransactionList = () => {
  const dateFns = new DateFnsUtils();
  const dispatch = useDispatch();
  const [transactionList, setTransactionList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [subscription, setIsSubscription] = useState({});
  const [currentIndex, setCurrentIndex] = useState(-1);

  let broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference;
  const translationsBrokerAdmin =
    translations[languagepreference].brokerageAdmin;

  const onTransactionOpenHandler = (id, index) => {
    setCurrentIndex(index);
    setButtonLoading(true);
    dispatch(transactionDetail(id)).then(() => {
      setButtonLoading(false);
      setCurrentIndex(-1);
      dispatch(transactionModalOpened());
    });
  };
  const transactionModalState = useSelector(getTransactionModalState);
  const allTransactions = useSelector(getAllTransactionList);
  const detail = useSelector(getTransactionDetails);
  useEffect(() => {
    setIsLoading(true);
    dispatch(allTransactionsList()).then(() => {
      setIsLoading(false);
    });
  }, []);
  useEffect(() => {
    if (allTransactions) {
      setTransactionList(allTransactions);
    }
  });

  return (
    <>
      <Modal
        size="md"
        isOpen={transactionModalState}
        ariaHideApp={false}
        shouldCloseOnEsc={false}
        centered
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
          },
          content: {
            height: "80%",
            width: "50vw",
            position: "absolute",
            top: "15vh",
            left: "25vw",
            background: "#eef3f6",
            WebkitOverflowScrolling: "touch",
            border: "8px solid " + theme.COLORS.primary_navyblue,
            borderRadius: "20px",
            padding: 0,
          },
        }}
      >
        <TransactionDetails detail={detail} subscription={subscription} />
      </Modal>

      <h5
        className="px-2"
        style={{
          fontFamily: "GibsonSemiBd",
          justifyContent: "center",
          fontSize: "1.5vw",
          display: "flex",
          marginTop: "1rem",
          marginBottom: "1rem",
        }}
      >
        {translationsBrokerAdmin.transactionListTitle}
      </h5>

      {isLoading && (
        <div>
          <Loader3Orange />
        </div>
      )}

      <div
        className="d-flex m-2"
        style={{
          fontFamily: "GibsonRegular",
          paddingTop: "25px",
          fontSize: "0.9vw",
        }}
      >
        <table className="table table-sm ml-2">
          <thead>
            <tr>
              <th scope="col">{translationsBrokerAdmin.subscriptionName}</th>
              <th scope="col">{translationsBrokerAdmin.subscriptionPrice}</th>
              <th scope="col">{translationsBrokerAdmin.tax}</th>
              <th scope="col">{translationsBrokerAdmin.date}</th>
              <th scope="col">{translationsBrokerAdmin.totalAmount}</th>
              <th scope="col" className="text-center">
                {translationsBrokerAdmin.view}
              </th>
            </tr>
          </thead>
          <tbody>
            {transactionList && transactionList.length > 0 ? (
              transactionList.map((item, i) => {
                const city =
                  item.location ||
                  item.brokerages?.[0]?.address?.[0]?.city ||
                  item.brokerages?.[0]?.address?.city ||
                  "";

                return (
                  <Fragment key={item.id}>
                    <tr scope="row" className="thead-light rows">
                      <td style={{ paddingTop: "12px" }} scope="row">
                        {item.subscription_name ||
                          translationsBrokerAdmin.noData}
                      </td>
                      <td style={{ paddingTop: "12px" }} scope="row">
                        {item.subscription_price
                          ? `$${item.subscription_price}`
                          : "$ 0"}
                      </td>
                      <td style={{ paddingTop: "12px" }} scope="row">
                        {item.tax ? `$${item.tax}` : "$0"}
                      </td>
                      <td style={{ paddingTop: "12px" }} scope="row">
                        {dateFns.format(
                          new Date(item.createdAt),
                          "MMM dd, yyyy"
                        )}
                      </td>
                      <td style={{ paddingTop: "12px" }} scope="row">
                        {item.total_amount ? `$${item.total_amount}` : "$0"}
                      </td>
                      <td className="text-center">
                        <div>
                          {buttonLoading && currentIndex === i && (
                            <LoadingSpinner />
                          )}
                          <Button
                            className="list_btn"
                            style={{
                              color: "white",
                              height: "3.5vh",
                              fontFamily: "GibsonSemiBd",
                              fontSize: 12,
                              backgroundColor: theme.COLORS.secondary_skyblue,
                              border: 0,
                              width: "5vw",
                            }}
                            onClick={() => {
                              onTransactionOpenHandler(item.charge_id, i);
                              setIsSubscription(item);
                            }}
                          >
                            {translationsBrokerAdmin.view}
                          </Button>
                        </div>
                      </td>
                    </tr>
                  </Fragment>
                );
              })
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  {translationsBrokerAdmin.noTransactions}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default TransactionList;
